module.exports = __webpack_public_path__ + "media/flags/dm-89e9bc15.svg";